module.exports = __webpack_public_path__ + "img/delta_large.a427e8f6.jpeg";